export const NAME = 'DASHBOARD';

export const dashboardInfo = (store) => store[NAME].info.data;
